<div>
  <p-toast></p-toast>
  <p-table
    styleClass="p-datatable-gridlines"
    [value]="atividadeManobras"
    [scrollable]="true"
    scrollHeight="600px"
    [loading]="loading"
  >
    <ng-template pTemplate="header">
      <tr [style]="{ fontSize: '12px' }" class="font-grid-material-header">
        <th>Data</th>
        <th>Ação</th>
        <th>Equipe</th>
        <th>Tratamento</th>
        <th>Responsável</th>
        <th>Data do Tratamento</th>
        <th class="text-center" style="width: 8%">Ações</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-atividadeManobras let-i="index">
      <tr [style]="{ fontSize: '12px' }" class="font-grid-material">
        <td>{{ atividadeManobras.dataSolicitacao | date : 'dd/MM/yyyy HH:mm' }}</td>
        <td>{{ atividadeManobras.acao }}</td>
        <td>{{ atividadeManobras.equipe }}</td>
        <td>{{ atividadeManobras.tratamento }}</td>
        <td>{{ atividadeManobras.usuarioTratamento }}</td>
        <td>{{ atividadeManobras.dataTratamento | date : 'dd/MM/yyyy HH:mm' }}</td>
        <td class="text-center">
          <button
            pButton
            pRipple
            icon="pi pi-pencil"
            style="width: 30px; height: 30px; font-size: 10px"
            class="p-button-rounded p-button-success m-1"
            pTooltip="Editar Manobras"
            title="Editar Manobras"
            (click)="showDialog(atividadeManobras)"
            [disabled]="atividadeManobras.tratamento === 'Tratado'"
          ></button>
          <!---->
        </td>
      </tr>
    </ng-template>
  </p-table>

  <p-dialog header="Tratamento da Manobra" [modal]="true" [(visible)]="visible" [style]="{ width: '25rem' }">
    <div class="flex justify-content-center mb-8">
      <p-select
        [options]="optionsManobra"
        [(ngModel)]="valueManobra"
        optionLabel="name"
        placeholder="Selecione a Ação."
        [style]="{ width: '12rem' }"
      />
    </div>

    <div class="flex justify-content-end gap-2">
      <p-button
        icon="pi pi-times"
        label="Cancelar"
        severity="primary"
        variant="outlined"
        [style]="{width: '120px'}"
        (onClick)="visible = false"
      ></p-button>

      <p-button
        icon="pi pi-save"
        label="Salvar"
        severity="primary"
        (click)="updManobras()"
        pTooltip="Salvar"
        tooltipPosition="top"
        [style]="{width: '120px'}"
      ></p-button>
    </div>
  </p-dialog>
</div>
